export const pillars = ['Morning', 'Afternoon', 'Night', 'Progress'];
export const volumes = [{
  n: 1,
  emoji: '☀️',
  title: 'Wake Up',
  desc: 'A visual sequence that turns waking up into a calm start: get out of bed, open the curtains, get dressed. Your child sees the first three steps of the day and moves through them without being told twice.'
}, {
  n: 2,
  emoji: '🥣',
  title: 'Breakfast',
  desc: 'Cards and checkpoints for the whole breakfast moment — sit down, eat, clear the plate, brush teeth — so the morning stops depending on constant reminders.'
}, {
  n: 3,
  emoji: '🎒',
  title: 'School',
  desc: 'The leaving-the-house sequence made visible: shoes, backpack, water bottle, coat. One thing at a time, checked off as it happens, so nobody is searching for anything at the door.'
}, {
  n: 4,
  emoji: '🧺',
  title: 'Responsibilities',
  desc: 'Age-appropriate contribution cards for putting away toys, feeding pets and setting the table, presented as small visible steps instead of a list of orders.'
}, {
  n: 5,
  emoji: '🧩',
  title: 'Playtime',
  desc: 'Free play with a clear beginning and a clear end, including the transition out of play — the moment that usually causes the most resistance — shown before it happens.'
}, {
  n: 6,
  emoji: '🌙',
  title: 'Sleep',
  desc: 'The bedtime anchor sequence: bath, pajamas, story, lights out. Predictable, visual and repeatable, so nights become smooth instead of a nightly negotiation.'
}];
export const volumeIncludes = ['☀️ Morning, afternoon & night blocks', '🧩 Visual activity cards to choose from', '➕ Customizable activities for your family', '✅ Progress tracking for what is done', '📊 Daily progress percentage', '👤 Personalized names per child', '🔤 Large, easy-to-read text', '✨ Reduced animations for focus', '🖨️ Print option for the daily summary', '💾 Auto-save of every change', '📥 Backup & export of your data', '🚀 Optimized for mobile devices'];
export const bonuses = [{
  n: '01',
  title: 'The Neuro-Friendly Icon Vault',
  desc: "🎨 High-contrast, professional icons specifically designed for ADHD and Autistic minds to process tasks 3x faster without visual overwhelm.",
  price: '$47',
  cover: 'https://cdn.magicpatterns.com/uploads/rhyqP5DUmTKUNgtpfMh5tZ/ChatGPT_Image_5_sept_2026,_14_59_31.png'
}, {
  n: '02',
  title: 'Weekend & Holiday Transition Guide',
  desc: "🗓️ Keep the peace when school is out. A strategic roadmap to adapt your routine for unstructured days without losing progress.",
  price: '$37',
  cover: 'https://cdn.magicpatterns.com/uploads/w6nQb2CS3QtdsEFnttT252/ChatGPT_Image_5_sept_2026,_14_59_43.png'
}, {
  n: '03',
  title: 'Power Struggle Script Book',
  desc: "💬 Stop the nagging. The exact science-backed phrases to use when your child resists, turning conflict into calm cooperation instantly.",
  price: '$27',
  cover: 'https://cdn.magicpatterns.com/uploads/7wWyp9b7U4TTGDPrE7PP15/ChatGPT_Image_5_sept_2026,_14_59_47.png'
}, {
  n: '04',
  title: 'Print-and-Go Travel Routine Cards',
  desc: 'A pocket-sized card set for car trips, flights, grandparents’ houses and hotel rooms, so the routine travels with your child instead of being left at home.',
  price: '$19',
  cover: 'https://cdn.magicpatterns.com/uploads/hXVwSGEYg1ZMfinBnCAi9c/ChatGPT_Image_5_sept_2026,_14_59_52.png'
}, {
  n: '05',
  title: 'The Sleep-Anchor Checklist',
  desc: "😴 The ultimate bedtime sequence to lower cortisol and trigger natural melatonin, ensuring a peaceful transition to deep sleep.",
  price: '$27',
  cover: 'https://cdn.magicpatterns.com/uploads/i5CzhFS5nGmTNeLEXS6q6H/ChatGPT_Image_5_sept_2026,_14_59_56.png'
}];